import { Fragment } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { v4 as uuidv4 } from "uuid";
export const AddressBookCardSkeleton = ({ count = 2 }) => {
  return (
    <div className={"addressBook-group"}>
      {Array.from({ length: count }).map((_, index) => {
        const uid = uuidv4();
        return (
          <div className="addressbook-list" key={uid}>
            {/* Left side */}
            <div className="addressbook-listLft">
              {/* Radio */}
              <div className="custom-check">
                <Skeleton variant="circular" width={20} height={20} />
              </div>

              <div className="listedAddress">
                <Skeleton width={160} height={25} />
                <Skeleton width={180} height={16} />
                <Skeleton width={370} height={16} />
                <Skeleton width={180} height={16} />
                <Skeleton width={120} height={16} />
                <Skeleton width={180} height={16} />
              </div>
            </div>

            {/* Right side */}
            <div className="addressbook-listRht">
              <Skeleton width={40} height={16} />
            </div>
          </div>
        );
      })}
    </div>
  );
};
